import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPillsComponent } from './filter-pills.component';

@NgModule({
  declarations: [FilterPillsComponent],
  imports: [CommonModule],
  exports: [FilterPillsComponent]
})
export class FilterPillsModule { }
